module.exports = "https://cdn.hellotech.com/client-assets/surface_fireplace_fa9576e1939c5faaa62c0258084601ad.png";